import { render, staticRenderFns } from "./ConnectBinance.vue?vue&type=template&id=a8bc8dfc&"
import script from "./ConnectBinance.vue?vue&type=script&lang=js&"
export * from "./ConnectBinance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports